import axios from '../../plugins/axios';
import { mapGetters, mapActions } from 'vuex'

export default {
    data: function() {
        return {
            whichCaptcha: 'v3'
        };
    },
    computed: {
        showCaptchaError() {
            return false;
        },

        ...mapGetters({
            googleRecaptcha: 'settings/getGoogleRecaptcha'
        })
    },
    methods: {
        ...mapActions({
            setRecaptcha: 'recaptcha/setRecaptcha'
        }),
        insertRecaptchaJs() {
            let g3ApiScript = document.createElement('script');
            g3ApiScript.id = 'recaptcha';
            g3ApiScript.src = `https://www.google.com/recaptcha/api.js?render=${this.googleRecaptcha['recaptcha_v3']}`;
            document.head.append(g3ApiScript);
        },

        checkRecaptcha() {
            if(this.whichCaptcha == 'v3') {
                return new Promise((resolve) => {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(this.googleRecaptcha['recaptcha_v3'], { action: 'submit' }).then(async (token) => {
                            this.setRecaptcha({token: token, type: 'v3'});
                            resolve();
                        });
                    });
                });
            }
        },

        loadRecaptchaV2() {
            grecaptcha.ready(() => {
                grecaptcha.render('recaptcha-container', {
                    'sitekey': this.googleRecaptcha['recaptcha_v2'],
                    'callback' : (token) => this.checkRecaptchaV2(token)
                });
            });
        },

        async checkRecaptchaV2(token) {
            this.setRecaptcha({token: token, type: 'v2'});
        },

        tryWithCaptchaVersion(type = 'v3') {
            this.whichCaptcha = type;
        }
    },
};